<template lang="pug">
  .web-map
    #clickToDraw Click to draw point.
    #olMap
</template>

<script>
import {generateToken, initialize, toggleLegend} from '@/services/map'
import { getMapLayers } from '@/services/api'

export default {
  async mounted () {
    const token = await generateToken()
    let mapLayers = await getMapLayers()
    initialize('olMap', mapLayers, token)
    toggleLegend()
  }
}
</script>

<style lang="stylus" scoped>
  .web-map, #olMap
    height calc(100vh - 64px)
    @media screen and (max-width: 600px)
      height calc(100vh - 56px)
  #clickToDraw
    position absolute
    width 119px
    height 26px
    margin-top 5px
    margin-left 5px
    background-color #004f27
    font-size 12px
    color #fff
    z-index 1
    display flex
    align-items center
    justify-content center
    border-radius 3px
</style>
